export function update(field, value, form) {
  return function(state, props) {
    if (form) {
      return {
        ...state,
        [form]: {
          ...state[form],
          values: {
            ...state[form].values,
            [field]: value
          },
          errors: {
            ...state[form].errors,
            [field]: ""
          }
        }
      };
    }
    return {
      ...state,
      values: {
        ...state.values,
        [field]: value
      },
      errors: {
        ...state.errors,
        [field]: ""
      }
    };
  };
}
export function setError(field, error, form) {
  return function(state, props) {
    if (form) {
      return {
        ...state,
        [form]: {
          ...state[form],
          errors: {
            ...state[form].errors,
            [field]: error
          }
        }
      };
    }
    return {
      ...state,
      errors: {
        ...state.errors,
        [field]: error
      }
    };
  };
}

export function validate(schema, form) {
  return function(state, props) {
    const errors = schema.validate(state.values);
    const change = {
      ...this.state,
      errors
    };
    if (form) {
      return {
        ...state,
        [form]: change
      };
    }
    return change;
  };
}
